/* Zio Feed: hover önizleme + temanın medya lightbox'ı (PhotoSwipe, product-gallery ile aynı kurulum)
   Oynatma/ön-yükleme mantığı (Instagram önceliği): önce aktif video, ilk kare gelince komşu iki video ısıtılır. */
(function () {
  if (customElements.get('zio-feed')) return;

  function pauseMedia(media) {
    if (!media) return;
    media.paused = true;
    media.pause();
  }
  function playMedia(media, fromStart) {
    if (!media) return;
    var video = media.querySelector('video');
    // Tema, seek sırasında 'playing' özniteliğini bırakır; bayat kalırsa play() çalışmaz — temizle
    if (video && video.paused && media.hasAttribute('playing')) media.removeAttribute('playing');
    if (video && fromStart) { try { video.currentTime = 0; } catch (e) {} }
    media.paused = false;
    media.play();
  }
  function prefetch(video) {
    if (!video || video.__zioPrefetched) return;
    video.__zioPrefetched = true;
    video.preload = 'auto';
    try { video.load(); } catch (e) {}
  }
  function text(tag, className, value) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (value) el.textContent = value;
    return el;
  }

  class ZioFeed extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      var self = this;

      // Kart önizlemesi yalnız fare üstündeyken oynar; dokunmatikte hiç yüklenmez (poster kalır)
      if (!theme.config.isTouch) {
        this.querySelectorAll('.product-card__media').forEach(function (card) {
          var media = card.querySelector('video-media[data-zio-hover]');
          if (!media) return;
          card.addEventListener('mouseenter', function () { self.warm(); playMedia(media, false); });
          card.addEventListener('mouseleave', function () { pauseMedia(media); });
        });
      }

      // Bölüm görünür olunca lightbox modülü sessizce ısınır (ilk tıklamada bekleme olmasın)
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { self.warm(); io.disconnect(); }
        }, { rootMargin: '400px 0px' });
        io.observe(this);
      }
    }

    warm() {
      if (this._warm) return;
      this._warm = true;
      try { import(theme.settings.pswpModule); } catch (e) {}
    }

    get items() {
      return Array.from(this.querySelectorAll('[data-zio-item]'));
    }

    get uiTemplate() {
      return this.querySelector('template[data-zio-ui]');
    }

    onClick(event) {
      var button = event.target.closest('[data-zio-open]');
      if (!button || !this.contains(button)) return;
      event.preventDefault();
      var index = this.items.indexOf(button.closest('[data-zio-item]'));
      if (index < 0 || typeof PhotoSwipeLightbox === 'undefined') return;
      this.lightbox.loadAndOpen(index, this.items.map(this.buildSlide));
    }

    buildSlide(item) {
      var d = item.dataset;
      var ratio = parseFloat(d.ratio) || 0.5625;
      var thumb = item.querySelector('.media img');
      var poster = d.poster || (thumb ? (thumb.currentSrc || thumb.src) : '');
      return {
        type: 'video',
        thumbnailElement: thumb,
        src: poster,
        msrc: thumb ? (thumb.currentSrc || thumb.src) : poster,
        width: 1080,
        height: Math.round(1080 / ratio),
        alt: d.name || '',
        thumbCropped: true,
        zio: {
          video: d.video,
          poster: poster,
          loop: d.loop === 'true',
          name: d.name || '',
          desc: d.desc || '',
          avatar: d.avatar || '',
          followTemplate: item.querySelector('template[data-zio-follow]')
        }
      };
    }

    // Komşu slaytların videolarını ısıt (aktif videonun ilk karesinden SONRA çağrılır)
    prefetchNeighbors(pswp) {
      if (!pswp || !pswp.mainScroll) return;
      pswp.mainScroll.itemHolders.forEach(function (holder) {
        var slide = holder.slide;
        if (!slide || slide.index === pswp.currIndex || !slide.content || !slide.content.element) return;
        prefetch(slide.content.element.querySelector('video'));
      });
    }

    buildVideoSlide(content) {
      var z = content.data.zio;
      var wrap = document.createElement('div');
      wrap.className = 'pswp__video-container zio-pswp__video';

      var media = document.createElement('video-media');
      media.className = 'block w-full h-full';
      media.style.setProperty('--aspect-ratio', String(content.data.width / content.data.height));

      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      if (z.loop) video.setAttribute('loop', '');
      video.preload = 'none';
      if (z.poster) video.poster = z.poster;
      var source = document.createElement('source');
      source.src = z.video;
      source.type = 'video/mp4';
      video.appendChild(source);
      media.appendChild(video);

      // Oynat/duraklat düğmesi: bölümdeki video kartlarının aynısı (Liquid'de render edildi)
      var playTpl = this.uiTemplate && this.uiTemplate.content.querySelector('.zio-pswp__play');
      if (playTpl) {
        var poster = document.importNode(playTpl.querySelector('.deferred-poster'), true);
        poster.id = 'DeferredPoster-zio-' + content.index;
        poster.querySelector('.play-button').setAttribute('aria-labelledby', poster.id);
        media.appendChild(poster);
      }

      // Yükleniyor çizgisi: oynatma istendi ama kare yok / ara tamponlama
      var setLoading = function (on) { wrap.classList.toggle('is-loading', on); };
      video.addEventListener('play', function () { if (video.readyState < 3) setLoading(true); });
      video.addEventListener('waiting', function () { setLoading(true); });
      video.addEventListener('playing', function () { setLoading(false); });
      video.addEventListener('pause', function () { setLoading(false); });
      video.addEventListener('error', function () { setLoading(false); });

      wrap.appendChild(media);

      // Sol alt: avatar + @hesap + Takip Et, altında açıklama (Reels düzeni)
      if (z.name || z.desc || z.followTemplate) {
        var cap = text('div', 'zio-pswp__caption');
        var row = text('div', 'zio-pswp__row');
        var avatar = text('span', 'zio-pswp__avatar');
        if (z.avatar) {
          var img = document.createElement('img');
          img.src = z.avatar; img.alt = ''; img.loading = 'lazy'; img.width = 40; img.height = 40;
          avatar.appendChild(img);
        } else if (z.name) {
          avatar.appendChild(text('span', 'zio-pswp__initial', z.name.replace(/^@/, '').charAt(0).toUpperCase()));
        }
        if (z.avatar || z.name) row.appendChild(avatar);
        if (z.name) row.appendChild(text('span', 'zio-pswp__name', z.name));
        if (z.followTemplate) row.appendChild(document.importNode(z.followTemplate.content, true));
        cap.appendChild(row);
        if (z.desc) cap.appendChild(text('p', 'zio-pswp__desc', z.desc));
        wrap.appendChild(cap);
      }
      return wrap;
    }

    get lightbox() {
      if (this._lightbox) return this._lightbox;
      var self = this;

      var lightbox = new PhotoSwipeLightbox({
        bgOpacity: 1,
        mainClass: 'zio-pswp',
        pswpModule: function () { return import(theme.settings.pswpModule); },
        preload: [1, 1],
        loop: false,
        arrowPrev: false,
        arrowNext: false,
        close: false,
        counter: false,
        zoom: false,
        preloader: false,
        allowPanToNext: false,
        allowMouseDrag: true,
        wheelToZoom: false,
        returnFocus: true
      });

      lightbox.addFilter('thumbEl', function (_thumbEl, data) { return data.thumbnailElement; });

      lightbox.on('contentLoad', function (event) {
        if (event.content.type !== 'video') return;
        event.preventDefault();
        event.content.element = self.buildVideoSlide(event.content);
      });

      // Ses/oynatma disiplini: yalnız aktif slayt oynar; eski slayt önce durur; yenisi baştan başlar
      lightbox.on('contentActivate', function (event) {
        var el = event.content.element;
        var media = el && el.querySelector('video-media');
        var video = el && el.querySelector('video');
        if (!media || !video) return;
        video.preload = 'auto';
        playMedia(media, true);
        var pswp = lightbox.pswp;
        var onFirstFrame = function () {
          video.removeEventListener('playing', onFirstFrame);
          self.prefetchNeighbors(pswp);
        };
        video.addEventListener('playing', onFirstFrame);
        // Oynatma engellenirse (ses politikası) komşuları yine ısıt
        setTimeout(function () { if (video.paused) self.prefetchNeighbors(pswp); }, 1500);
      });
      lightbox.on('contentDeactivate', function (event) {
        var el = event.content.element;
        pauseMedia(el && el.querySelector('video-media'));
      });
      lightbox.on('close', function () {
        var pswp = lightbox.pswp;
        if (pswp && pswp.element) pswp.element.querySelectorAll('video-media').forEach(pauseMedia);
      });

      // Kapat + oklar: bölümün kendi butonları (template'ten klon), PhotoSwipe'ın pilleri kapalı
      lightbox.on('uiRegister', function () {
        lightbox.pswp.ui.registerElement({
          name: 'zio-ui',
          order: 9,
          isButton: false,
          appendTo: 'root',
          onInit: function (el, pswp) {
            var tpl = self.uiTemplate;
            if (!tpl) return;
            var frag = document.importNode(tpl.content, true);
            frag.querySelector('.zio-pswp__play').remove();
            el.appendChild(frag);
            var prev = el.querySelector('[data-zio-prev]');
            var next = el.querySelector('[data-zio-next]');
            el.querySelector('[data-zio-close]').addEventListener('click', function () { pswp.close(); });
            prev.addEventListener('click', function () { pswp.prev(); });
            next.addEventListener('click', function () { pswp.next(); });
            var sync = function () {
              prev.disabled = pswp.currIndex <= 0;
              next.disabled = pswp.currIndex >= pswp.getNumItems() - 1;
            };
            pswp.on('change', sync);
            sync();
          }
        });
      });

      lightbox.init();
      return this._lightbox = lightbox;
    }
  }

  customElements.define('zio-feed', ZioFeed);
})();
